import supabase from '../supabase/supabase';

const normalize = (row) => ({
  ...row,
  listingId: row.listing_id,
  chatId: row.chat_id,
  requesterId: row.requester_id,
  providerId: row.provider_id,
  pickupAt: row.pickup_at,
  expiresAt: row.expires_at,
  createdAt: row.created_at,
  updatedAt: row.updated_at,
});

const normalizePickupAt = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) throw new Error('Die gewünschte Abholzeit ist ungültig.');
  return date.toISOString();
};

export const reservationService = {
  async getMine(userId) {
    if (!userId) return [];
    const { data, error } = await supabase
      .from('reservations')
      .select('*')
      .or(`requester_id.eq.${userId},provider_id.eq.${userId}`)
      .order('created_at', { ascending: false });
    if (error) throw error;
    return (data || []).map(normalize);
  },

  async create({ listingId, quantity, chatId = null, pickupAt = null, note = '' }) {
    const { data, error } = await supabase.rpc('create_reservation', {
      p_listing_id: listingId,
      p_quantity: Math.max(1, Number.parseInt(quantity, 10) || 1),
      p_chat_id: chatId || null,
      p_pickup_at: normalizePickupAt(pickupAt),
      p_note: note.trim() || null,
    });
    if (error) throw error;
    return normalize(data);
  },

  async updateStatus(reservationId, status) {
    const { data, error } = await supabase.rpc('update_reservation_status', {
      p_reservation_id: reservationId,
      p_status: status,
    });
    if (error) throw error;
    return normalize(data);
  },
};
